import { render } from "./WorkWithUs.vue?vue&type=template&id=73a2f312&scoped=true&ts=true"
import script from "./WorkWithUs.vue?vue&type=script&lang=ts"
export * from "./WorkWithUs.vue?vue&type=script&lang=ts"

import "./WorkWithUs.vue?vue&type=style&index=0&id=73a2f312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a2f312"]])

export default __exports__